<template>
  <div class="w-full">
    <div class="w-full md:px-6 px-2">
      <div class="md:flex md:flex-wrap">
        <div
          class="py-10 md:w-full lg:w-3/3 w-full md:pr-6"
        >
        <div class="mx-auto w-4/5 text-left font-raleway z-10">
        <h1 class="font-bold text-black text-6xl mb-10 text-3xl text-gray-900 font-bold mb-10"><i>Willkommen</i> auf der eduBB Plattform für <b>Autoren und Azubis</b></h1>
<!--         <font-awesome-icon class="text-xl" :icon="['fas', 'user-circle']" /> {{ user.firstName }} {{ user.lastName }} 
        <p></p>
        <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-at']" /> {{ user.email }} 🙌 -->
        </div>
<!-- Dashboard -->
          
<!--           // Diesen Button für Menuführung nutzen
            <button
              class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"
            >
              <router-link to="/courses"> Kurse anzeigen </router-link>
            </button>      -->

<!--           // Selection Felder für alternative Menuführung  
            <select
              aria-label="Selected tab"
              class="form-select block w-full p-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent relative z-10"
            >
              <option selected class="text-sm text-gray-600">
                Metrics
              </option>
              <option class="text-sm text-gray-600">Notifications</option>
              <option class="text-sm text-gray-600">Announcements</option>
            </select> -->

            <!-- <time-line /> -->
            <!-- INFO SECTION -->
          <b-message type="is-info">
            <h1 class="title">Seminare und Workshops</h1>
            <h2 class="text-xl tracking-wide font-montserrat mb-10">
              Ab sofort werden auch Seminare und kommende Workshops auf der eduBB Plattform angeboten. 
            </h2>
            <div class="buttons mt-2">
              <b-button 
              class="text-xl"
              tag="router-link"
                to="/seminars"
              type="is-info" 
              expanded>
              Seminare anzeigen</b-button>
            </div>
          </b-message>

          <!-- INFO SECTION -->
          <b-message type="is-info">
            <b-tag type="is-dark">NEU</b-tag>
            <h1 class="title">Webinare</h1>
            <h2 class="text-xl tracking-wide font-montserrat mb-10">
              Inhalte zum anfassen und jederzeit abrufbar. Experten haben Webinare für dich entwickelt um wichtige und komplexe Themenfelder anfassbar zu machen. 
            </h2>
            <div class="buttons mt-2">
              <b-button 
              class="text-xl"
              tag="router-link"
                to="/webinar"
              type="is-info" 
              expanded>
              Webinare anzeigen</b-button>
            </div>
          </b-message>

<!--  Hero Section -->
        <br>
          <StudentSection class="card py-10 w-full px-6" />
            <HeroSection/>
            <router-link to='/courses'>
          </router-link>
<!-- featured section -->
<!--             <section class="text-left font-montserrat mx-5 z-10">
                <br>
                <h2 class="text-6xl font-black my-10 z-10 font-bold text-black text-6xl mb-10 text-3xl text-gray-900 font-bold mb-10">Wie werden die Contentmodule geprüft und wie kann ich selbst ein Contentmodul zur eduBB hinzufügen?</h2>
                  <br>
                  <div class="video">
                    <video controls class="video-width">
                    <source 
                      :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_QMS_01_2be19aa860.mp4'" 
                      :type="mp4"/>
                    Sorry, your browser doesn't support embedded videos.
                    </video>
                  </div>
                  <div class="flex items-center">
                    HOW TO:&nbsp;
                  <font-awesome-icon class="red-color" icon="fa-file-pdf" />
                    <a :href="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_01_beff55d88c.pdf'" target="_blank">&nbsp;
                      Tutorial Anleitung
                    </a>
                  </div>
            </section> -->
<!--           <h1 class="text-3xl text-gray-900 font-bold mb-10">Summary</h1>
          <h2 class="text-gray-900 text-xl mb-6">Courses progress</h2>
          <div
            class="mb-6 bg-white w-full border-r-4 border-blue-500 px-4 pt-5 pb-8 shadow-md"
          >
            <p class="mb-3 text-gray-600 text-sm">Marketing</p>
            <div class="mb-3 md:flex items-center justify-between">
              <h4 class="text-gray-800 font-medium md:w-2/5 w-full">
                Introduction to Consumer Behavior
              </h4>
              <ul class="md:flex items-center justify-between md:pl-6 md:w-3/5">
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 hours, 30 minutes</p>
                </li>
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 modules</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>17 Aug - 19 Sept</p>
                </li>
              </ul>
            </div>
            <div class="md:flex items-center">
              <div class="md:w-2/5 md:mb-0 mb-4">
                <p class="text-sm text-gray-600">
                  Explores the introductory areas of investment banking in the
                  modern day and age
                </p>
              </div>
              <div class="md:pl-6 md:w-3/5">
                <div class="container mx-auto">
                  <div class="w-full mx-auto">
                    <div class="h-1 bg-gray-200 rounded">
                      <div
                        class="w-7/12 bg-blue-500 h-1 rounded relative"
                      ></div>
                    </div>
                    <div class="flex justify-end items-center pt-1">
                      <p class="text-xs text-blue-500 font-bold">
                        63% Complete
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mb-6 bg-white w-full border-r-4 border-gray-800 px-4 pt-5 pb-8 shadow-md"
          >
            <p class="mb-3 text-gray-600 text-sm">Marketing</p>
            <div class="mb-3 md:flex items-center justify-between">
              <h4 class="text-gray-800 font-medium md:w-2/5 w-full">
                Introduction to Consumer Behavior
              </h4>
              <ul class="md:flex items-center justify-between md:pl-6 md:w-3/5">
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 hours, 30 minutes</p>
                </li>
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 modules</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>17 Aug - 19 Sept</p>
                </li>
              </ul>
            </div>
            <div class="md:flex items-center">
              <div class="md:w-2/5">
                <p class="text-sm text-gray-600">
                  Explores the introductory areas of investment banking in the
                  modern day and age
                </p>
              </div>
              <div class="md:pl-6 md:w-3/5">
                <div class="container mx-auto">
                  <div class="w-full mx-auto">
                    <div class="h-1 bg-gray-200 rounded">
                      <div
                        class="w-7/12 bg-gray-800 h-1 rounded relative"
                      ></div>
                    </div>
                    <div class="flex justify-end items-center pt-1">
                      <p class="text-xs text-gray-800 font-bold">
                        63% Complete
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mb-6 bg-white w-full border-r-4 border-gray-800 px-4 pt-5 pb-8 shadow-md"
          >
            <p class="mb-3 text-gray-600 text-sm">Marketing</p>
            <div class="mb-3 md:flex items-center justify-between">
              <h4 class="text-gray-800 font-medium md:w-2/5 w-full">
                Introduction to Consumer Behavior
              </h4>
              <ul class="md:flex items-center justify-between md:pl-6 md:w-3/5">
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 hours, 30 minutes</p>
                </li>
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 modules</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>17 Aug - 19 Sept</p>
                </li>
              </ul>
            </div>
            <div class="md:flex items-center">
              <div class="md:w-2/5">
                <p class="text-sm text-gray-600">
                  Explores the introductory areas of investment banking in the
                  modern day and age
                </p>
              </div>
              <div class="md:pl-6 md:w-3/5">
                <div class="container mx-auto">
                  <div class="w-full mx-auto">
                    <div class="h-1 bg-gray-200 rounded">
                      <div
                        class="w-7/12 bg-gray-800 h-1 rounded relative"
                      ></div>
                    </div>
                    <div class="flex justify-end items-center pt-1">
                      <p class="text-xs text-gray-800 font-bold">
                        63% Complete
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mb-6 bg-white w-full border-r-4 border-blue-500 px-4 pt-5 pb-8 shadow-md"
          >
            <p class="mb-3 text-gray-600 text-sm">Marketing</p>
            <div class="mb-3 md:flex items-center justify-between">
              <h4 class="text-gray-800 font-medium md:w-2/5 w-full">
                Introduction to Consumer Behavior
              </h4>
              <ul class="md:flex items-center justify-between md:pl-6 md:w-3/5">
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 hours, 30 minutes</p>
                </li>
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 modules</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>17 Aug - 19 Sept</p>
                </li>
              </ul>
            </div>
            <div class="md:flex items-center">
              <div class="md:w-2/5">
                <p class="text-sm text-gray-600">
                  Explores the introductory areas of investment banking in the
                  modern day and age
                </p>
              </div>
              <div class="md:pl-6 md:w-3/5">
                <div class="container mx-auto">
                  <div class="w-full mx-auto">
                    <div class="h-1 bg-gray-200 rounded">
                      <div
                        class="w-7/12 bg-blue-500 h-1 rounded relative"
                      ></div>
                    </div>
                    <div class="flex justify-end items-center pt-1">
                      <p class="text-xs text-blue-500 font-bold">
                        63% Complete
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg-white w-full border-r-4 border-blue-500 px-4 pt-5 pb-8 shadow-md"
          >
            <p class="mb-3 text-gray-600 text-sm">Marketing</p>
            <div class="mb-3 md:flex items-center justify-between">
              <h4 class="text-gray-800 font-medium sm:w-2/5">
                Introduction to Consumer Behavior
              </h4>
              <ul class="md:flex items-center justify-between md:pl-6 md:w-3/5">
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 hours, 30 minutes</p>
                </li>
                <li
                  class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>3 modules</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>17 Aug - 19 Sept</p>
                </li>
              </ul>
            </div>
            <div class="md:flex items-center">
              <div class="md:w-2/5">
                <p class="text-sm text-gray-600">
                  Explores the introductory areas of investment banking in the
                  modern day and age
                </p>
              </div>
              <div class="md:pl-6 md:w-3/5">
                <div class="container mx-auto">
                  <div class="w-full mx-auto">
                    <div class="h-1 bg-gray-200 rounded">
                      <div
                        class="w-7/12 bg-blue-500 h-1 rounded relative"
                      ></div>
                    </div>
                    <div class="flex justify-end items-center pt-1">
                      <p class="text-xs text-blue-500 font-bold">
                        63% Complete
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
<!--         <div class="py-10 lg:w-1/3 w-full md:pl-6 md:px-0 px-4">
          <h3 class="mb-10 text-gray-900 font-medium text-xl">
            My Progress
          </h3>

          <div class="sm:hidden relative w-11/12 mx-auto rounded">
            <div class="absolute inset-0 m-auto mr-4 z-0 w-6 h-6">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-selector"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#A0AEC0"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <polyline points="8 9 12 5 16 9" />
                <polyline points="16 15 12 19 8 15" />
              </svg>
            </div>
            <select
              aria-label="Selected tab"
              class="form-select block w-full p-3 border border-gray-300 rounded text-gray-600 appearance-none bg-transparent relative z-10"
            >
              <option selected class="text-sm text-gray-600">
                Metrics
              </option>
              <option class="text-sm text-gray-600">Notifications</option>
              <option class="text-sm text-gray-600">Announcements</option>
            </select>
          </div>
          <div class="justify-between flex-wrap hidden sm:block">
            <div
              class="xl:w-full xl:mx-0 border-b border-gray-300 rounded h-12"
            >
              <ul class="flex items-center text-gray-600 xl:justify-between">
                <li
                  :class="{
                    'bg-gray-100 text-blue-500': tab === 'Metrics',
                  }"
                  v-on:click="activeTab('Metrics')"
                  class="text-sm py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Metrics
                </li>
                <li
                  :class="{
                    'bg-gray-100 text-blue-500': tab === 'Notifications',
                  }"
                  v-on:click="activeTab('Notifications')"
                  class="text-sm py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Notifications
                </li>
                <li
                  :class="{
                    'bg-gray-100 text-blue-500': tab === 'Annoucements',
                  }"
                  v-on:click="activeTab('Annoucements')"
                  class="text-sm py-2 px-4 rounded text-sm cursor-pointer"
                >
                  Announcements
                </li>
              </ul>
            </div>
            <div class="mt-8 mb-2">
              <div class="flex flex-col items-center">
                <div class="w-16 h-16 rounded-full mb-3">
                  <img
                    class="w-full h-full overflow-hidden object-cover rounded-full"
                    src="https://image.freepik.com/free-photo/indoor-picture-cheerful-handsome-young-man-having-folded-hands-looking-directly-smiling-sincerely-wearing-casual-clothes_176532-10257.jpg"
                    alt
                  />
                </div>
                <h5 class="mb-2 text-gray-800">Timothy Jon Oliphant</h5>
                <p class="text-gray-600 text-xs">Marketing Professional</p>
              </div>
              <div class="mt-8 flex items-center">
                <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 mr-2">
                  <h3
                    class="mb-1 text-gray-800 text-center text-3xl font-medium"
                  >
                    16
                  </h3>
                  <p class="text-sm text-center text-gray-600">
                    Courses Completed
                  </p>
                </div>
                <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 ml-2">
                  <h3
                    class="mb-1 text-gray-800 text-center text-3xl font-medium"
                  >
                    14
                  </h3>
                  <p class="text-sm text-center text-gray-600">
                    Certificates Earned
                  </p>
                </div>
              </div>
              <div class="mt-4 flex items-center">
                <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 mr-2">
                  <h3
                    class="mb-1 text-gray-800 text-center text-3xl font-medium"
                  >
                    08
                  </h3>
                  <p class="text-sm text-center text-gray-600">
                    Courses in Progress
                  </p>
                </div>
                <div class="w-full md:w-1/2 bg-gray-100 py-8 px-4 ml-2">
                  <h3
                    class="mb-1 text-gray-800 text-center text-3xl font-medium"
                  >
                    22
                  </h3>
                  <p class="text-sm text-center text-gray-600">
                    Forum Discussions
                  </p>
                </div>
              </div>
            </div>
          </div>

          <hr class="border-t border-gray-300 my-8" />
          <div class="mb-6">
            <div class="flex items-center">
              <div class="w-10 h-10 rounded-full flex-shrink-0">
                <img
                  class="w-full h-full object-cover object-center"
                  src="../assets/images/enrolled-student-8.png"
                  alt
                />
              </div>
              <div class="ml-2 w-full">
                <h5 class="text-gray-800 text-sm">John Doe</h5>
                <div class="md:flex items-center justify-between w-full">
                  <p class="text-xs text-gray-600">Manager</p>
                  <p class="text-xs text-blue-500">
                    Introduction to Consumer Behavior
                  </p>
                </div>
              </div>
            </div>
            <p class="mt-3 text-gray-600 text-sm">
              The psychological factors that determine consumer behavior are
              pivotal in understanding the course
            </p>
          </div>
          <div class="mb-6">
            <div class="flex items-center">
              <div class="w-10 h-10 rounded-full flex-shrink-0">
                <img
                  class="w-full h-full object-cover object-center"
                  src="../assets/images/enrolled-student-8.png"
                  alt
                />
              </div>
              <div class="ml-2 w-full">
                <h5 class="text-gray-800 text-sm">John Doe</h5>
                <div class="md:flex items-center justify-between w-full">
                  <p class="text-xs text-gray-600">Manager</p>
                  <p class="text-xs text-blue-500">
                    Introduction to Consumer Behavior
                  </p>
                </div>
              </div>
            </div>
            <p class="mt-3 text-gray-600 text-sm">
              Do the certifications enhance career options and growth?
            </p>
          </div>
          <div class="mb-6">
            <div class="flex items-center">
              <div class="w-10 h-10 rounded-full flex-shrink-0">
                <img
                  class="w-full h-full object-cover object-center"
                  src="../assets/images/enrolled-student-8.png"
                  alt
                />
              </div>
              <div class="ml-2 w-full">
                <h5 class="text-gray-800 text-sm">John Doe</h5>
                <div class="md:flex items-center justify-between w-full">
                  <p class="text-xs text-gray-600">Manager</p>
                  <p class="text-xs text-blue-500">
                    Introduction to Consumer Behavior
                  </p>
                </div>
              </div>
            </div>
            <p class="mt-3 text-gray-600 text-sm">
              Do the certifications enhance career options and growth?
            </p>
          </div>
          <div>
            <div class="flex items-center">
              <div class="w-10 h-10 rounded-full flex-shrink-0">
                <img
                  class="w-full h-full object-cover object-center"
                  src="../assets/images/enrolled-student-8.png"
                  alt
                />
              </div>
              <div class="ml-2 w-full">
                <h5 class="text-gray-800 text-sm">John Doe</h5>
                <div class="md:flex items-center justify-between w-full">
                  <p class="text-xs text-gray-600">Manager</p>
                  <p class="text-xs text-blue-500">
                    Introduction to Consumer Behavior
                  </p>
                </div>
              </div>
            </div>
            <p class="mt-3 text-gray-600 text-sm">
              The psychological factors that determine consumer behavior are
              pivotal in understanding the course
            </p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>

import HeroSection from '../components/HeroSection.vue'
import StudentSection from '../components/StudentSection.vue'
// import TimeLine from '../views/components/timeline/Timeline.vue'

export default {
  name: "Profession",
  components: {
    HeroSection,
    StudentSection,
    // TimeLine
  },
  data: function() {
    return {
        user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
        tab: "Metrics",
        API_URL:
        process.env.NODE_ENV == "production"
          ? process.env.VUE_APP_STRAPI_API_URL
          : "localhost:1338",
    };
  },

 
  methods: {
    activeTab(element) {
      if (element === "Metrics") {
        this.tab = "Metrics";
      } else if (element === "Notifications") {
        this.tab = "Notifications";
      } else if (element === "Annoucements") {
        this.tab = "Annoucements";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
  text-align: left;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
     .image {
         height: 200px;
     }
     .video {
         margin-top: 5rem;
         margin-bottom: 5rem;
     }
     .video-width {
         width: 100%;
     }
     
     @media (max-width: 700px) {
         .long {
             max-width: 100%;
             flex-basis: 100%;
         }
         .image {
             width: 100%;
             height: 100%;
         }
     }
</style>
